<template>
  <div id="evaluationcomment" class="evaluationcomment" >

    <b-modal id="modalComment" title="Comment" @ok="saveComment">
      <form>
        <b-form-textarea v-model="commentData.teacherRemark"
                         placeholder="Add a comment"
                         :rows="4"></b-form-textarea>
      </form>
    </b-modal>
  </div>
</template>
<script>
import api from '../api'

export default {
  name: 'EvaluationComment',
  props: ['selectedEvaluations', 'selectedEvaluation', 'commentData', 'evaluations'],
  methods: {
    saveComment: function () {
      if (this.selectedEvaluations.length > 1) {
        for (var i in this.selectedEvaluations) {
          api.addTeachersComment(this.selectedEvaluations[i], this.commentData.teacherRemark)
          this.changeEvaluationComment(this.selectedEvaluations[i], this.commentData.teacherRemark)
        }
      } else {
        api.addTeachersComment(this.selectedEvaluation.id, this.commentData.teacherRemark)
      }
    },

    changeEvaluationComment: function (evaluationId, teacherRemark) {
      for (var i in this.evaluations) {
        if (this.evaluations[i].id === evaluationId) {
          this.evaluations[i].teacherRemark = teacherRemark
          break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvaluationComment.vue